import type { Area, Category } from './types';

export type { Area, Category };

export const AREA_LABELS: Record<Area, string> = {
  'st-pete': 'St. Pete',
  tampa: 'Tampa',
  clearwater: 'Clearwater',
  brandon: 'Brandon',
  sarasota: 'Sarasota',
  online: 'Online',
  other: 'Other',
};

export const CATEGORY_LABELS: Record<Category, string> = {
  chamber: 'Chamber',
  bni: 'BNI / Referral',
  meetup: 'Meetup',
  nonprofit: 'Nonprofit',
  mixer: 'Mixer',
  workshop: 'Workshop',
  other: 'Other',
};

/** Ordered lists for pills + selects. */
export const AREAS = Object.keys(AREA_LABELS) as Area[];
export const CATEGORIES = Object.keys(CATEGORY_LABELS) as Category[];
